import styled from 'styled-components';
import { layout, remCalc } from '@prisjakt/ui-base';
import Selectable from './components/selectable/selectable';

export const NoResults = styled.div`
  display: flex;
  padding: ${layout.measurements.spacing100} 10px;
`;
export const ShowAllSelectable = styled(Selectable)`
  padding-top: 10px;
`;

interface ListBoxProps {
  simple: boolean;
}
export const ProductListBox = styled.div<ListBoxProps>`
  padding-top: ${p => (p.simple ? '0' : '10px')};
`;

export const CategoryListBox = styled.div<ListBoxProps>`
  padding-top: ${p => (p.simple ? '0' : '10px')};
  background: white;
`;
export const NoResultContainer = styled.div`
  padding-top: ${remCalc(15)};
`;
